"use client";

import React, { useCallback, useEffect } from "react";
import { useStoredState, openIntercom } from "@thenounproject/lingo-core";
import { NavPoint, NavPointTypes } from "@redux/navPoint/NavPoint";
import BannerBar from "./BannerBar";

const productNavTypes = new Set([
  NavPointTypes.Products,
  NavPointTypes.ProductDetail,
  NavPointTypes.Markets,
  NavPointTypes.Integrations,
  NavPointTypes.ProductTypes,
]);

const ProductsBetaBanner: React.FC<{ navPoint: NavPoint }> = ({ navPoint }) => {
  const [dismissed, setDismissed] = useStoredState<Date>("products-beta-banner-dismissed", null),
    dismiss = useCallback(() => setDismissed(new Date()), [setDismissed]),
    giveFeedback = useCallback(() => {
      openIntercom({
        message: "I have some feedback about the Products beta",
        launchChat: true,
      });
    }, []);

  useEffect(() => {
    // clear dismissal every 7 days
    if (dismissed) {
      const now = new Date();
      const dismissedDate = new Date(dismissed);
      const timeSinceDismissal = now.getTime() - dismissedDate.getTime();
      if (timeSinceDismissal > 7 * 24 * 60 * 60 * 1000) {
        setDismissed(null);
      }
    }
  }, [dismissed, setDismissed]);

  if (dismissed || !productNavTypes.has(navPoint?.type)) return null;

  return (
    <BannerBar
      bannerStyle="warning"
      size="small"
      message={[
        "Products is currently in beta. Please ",
        { text: "contact us", onClick: giveFeedback },
        " with any feedback to help us improve it.",
      ]}
      onDismiss={dismiss}
    />
  );
};

export default ProductsBetaBanner;
